<template>
  <v-card width="100%" height="100%">
    <v-card-title>
      <!--      <v-btn text small @click="$router.push({ name: 'TrainingList' })">-->
      <!--        <v-icon left> mdi-arrow-left </v-icon>-->
      <!--        Back-->
      <!--      </v-btn>-->
      <v-spacer></v-spacer>
      <v-btn depressed color="primary" @click="download(document)">
        download
      </v-btn>
    </v-card-title>

    <v-divider></v-divider>
    <v-card-text style="height: 85vh; overflow-y: scroll" id="scollStyle">
      <!-- <pdf :src="url + document" /> -->
      <pdf
        v-for="i in pageCount(document)"
        :key="i"
        :page="i"
        :src="`data:${mime};base64, ${document}`"
        class=""
      ></pdf>
      <pdf />
    </v-card-text>
  </v-card>
</template>
<script>
import pdf from "vue-pdf";
import FileMixin from "../mixins/FileMixin";
import helpers from "../helpers/helper";
import RouterMixin from "../mixins/RouterMixin.js";

export default {
  name: "FeedbackDocument",
  components: { pdf },
  mixins: [FileMixin, RouterMixin],
  data() {
    return {
      url: process.env.VUE_APP_FILE_API,
      mime: "",
      ext: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) =>
      v.$store.dispatch("Feedback/getFeedbackDocument", {
        docNo: v.decodeRoute(to.params.docNo),
        code: v.decodeRoute(to.params.code),
        empNo: v.decodeRoute(to.params.reference),
      })
    );
  },
  computed: {
    document() {
      return this.$store.getters["Feedback/feedbackGetters"](
        "feedbackDocument"
      )[0];
    },
  },
  methods: {
    getPages: function (document) {
      if (document.length !== 0) {
        document = pdf.createLoadingTask(document);
        document.promise.then((pdf) => {
          this.numPages = pdf._pdfInfo.numPages;
        });
        return this.numPages;
      }
    },
    download(item) {
      var a = document.createElement("a");
      this.mime = helpers.detectMimeType(item);
      this.ext = helpers.fileExtension(item);
      a.href = `data:${this.mime};base64,${item}`;
      a.download = `Attachment.${this.ext}`;
      a.click();
    },
  },
};
</script>
